<div class="d-flex">
    <app-sidebar></app-sidebar>
    <div class="flex-grow-1 d-flex flex-column" style="height: 100vh; overflow-y: auto;">
        <app-header></app-header>
        <div class="p-4">
            <router-outlet></router-outlet>
        </div>
    </div>
</div>